import * as types from 'store/modules/hres62e/mutation-types'
import hres62e from 'api/hres62e'
import swal from 'sweetalert'
import hres62eLabels from 'assets/labels/hres62e'
import { hres62eMaxRowspan, hres62eColumns } from 'assets/columns/hres62e'
import configLabel from 'src/../config/label'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hres62eLabels,
    maxRowspan: hres62eMaxRowspan,
    columns: hres62eColumns(),
    index: {
      total: 0,
      rows: []
    },
    indexSelected: {},
    detail: {
      dtereq: '',
      seqno: 0,
      codleave: 'A',
      flgleave: '',
      dteleave: '',
      dtestrt: '',
      dteend: '',
      timstrt: '',
      timend: '',
      deslereq: '',
      staappr: ''
    },
    dropdowns: {
      codleave: {
        en: {},
        th: {}
      }
    },
    response: {
      status: '',
      data: ''
    },
    entitleFlagleave: {
      entitlement: {
        day3: '',
        hur3: '',
        min3: ''
      },
      enableflagleave: {
        r1: 'T',
        r2: 'T',
        r3: 'T',
        r4: 'T'
      }
    },
    worktime: {
      m_timstrt: '',
      m_timend: '',
      e_timstrt: '',
      e_timend: '',
      timstrt_tleaverq: '',
      timend_tleaverq: ''
    },
    popup: {}
  },
  getters: {
    [types.GET_HRES62E_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES62E_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES62E_MAX_ROWSPAN] (state) {
      return state.maxRowspan
    },
    [types.GET_HRES62E_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES62E_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES62E_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES62E_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES62E_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRES62E_DROPDOWNS] (state) {
      return state.dropdowns
    },
    [types.GET_HRES62E_ENTITLE_FLAG_LEAVE] (state) {
      return state.entitleFlagleave
    },
    [types.GET_HRES62E_WORKTIME] (state) {
      return state.worktime
    },
    [types.GET_HRES62E_POPUP] (state) {
      return state.popup
    }
  },
  mutations: {
    [types.SET_HRES62E_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES62E_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES62E_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
      }
    },
    [types.SET_HRES62E_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES62E_INDEX] (state, index) {
      state.index = index
    },
    [types.SET_HRES62E_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES62E_DETAIL] (state, detail) {
      state.detail = detail
      state.detail.filenam1_ = detail.filenam1
    },
    [types.SET_HRES62E_DROPDOWNS] (state, dropdowns) {
      state.dropdowns = dropdowns
    },
    [types.SET_HRES62E_ENTITLE_FLAG_LEAVE] (state, entitleFlagleave) {
      state.entitleFlagleave.entitlement = entitleFlagleave.entitlement
      state.entitleFlagleave.enableflagleave = entitleFlagleave.enableflagleave
    },
    [types.SET_HRES62E_WORKTIME] (state, worktime) {
      state.worktime = worktime
    },
    [types.SET_HRES62E_POPUP] (state, popup) {
      state.popup = popup
    },
    [types.SET_HRES62E_CODLEAVE] (state, codleave) {
      state.dropdowns.codleave = codleave
    }
  },
  actions: {
    [types.TOGGLE_HRES62E_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES62E_INDEX_DISP, indexDisp)
      commit(types.SET_HRES62E_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES62E_COLUMNS_LABELS] ({ commit }) {
      hres62e.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES62E_COLUMNS, data.labels)
          commit(types.SET_HRES62E_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.RECEIVED_HRES62E_INDEX] ({ commit }, searchParams) {
      hres62e.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          for (var i = 0; i < data.rows.length; i++) {
            let timstrt = ''
            let timend = ''
            if (typeof data.rows[i].timstrt !== 'undefined') {
              timstrt = (data.rows[i].timstrt.trim() === '') ? '' : ' ' + data.rows[i].timstrt.substring(0, 2) + ':' + data.rows[i].timstrt.substring(2, 4)
            }
            if (typeof data.rows[i].timend !== 'undefined') {
              timend = (data.rows[i].timend.trim() === '') ? '' : ' ' + data.rows[i].timend.substring(0, 2) + ':' + data.rows[i].timend.substring(2, 4)
            }
            data.rows[i].timstrt = timstrt
            data.rows[i].timend = timend
          }
          commit(types.SET_HRES62E_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRES62E_INDEX, objData)
        })
    },
    [types.RECEIVED_HRES62E_CREATE] ({ commit }, searchParams) {
      hres62e.getCreate(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES62E_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.RECEIVED_HRES62E_DETAIL] ({ commit }, searchParams) {
      hres62e.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES62E_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.RECEIVED_HRES62E_DROPDOWNS] ({ commit }) {
      hres62e.getDropdowns()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES62E_DROPDOWNS, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.RECEIVED_HRES62E_ENTITLE_FLAG_LEAVE] ({ commit }, searchParams) {
      if (searchParams.p_codleave !== '') {
        hres62e.getEntitleFlagLeave(searchParams)
          .then((response) => {
            const data = JSON.parse(response.request.response)
            commit(types.SET_HRES62E_ENTITLE_FLAG_LEAVE, data)
          })
          .catch((error) => {
            let message = error
            if (error.response) {
              const data = error.response.data
              message = data.response
            }
            console.warn('warning !!! Please Refresh Page', message)
            if (message !== '' && message !== undefined) {
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            }
          })
      } else {
        let data = {
          entitlement: {
            day3: '',
            hur3: '',
            min3: ''
          },
          enableflagleave: {
            r1: 'F',
            r2: 'F',
            r3: 'F',
            r4: 'F'
          }
        }
        commit(types.SET_HRES62E_ENTITLE_FLAG_LEAVE, data)
      }
    },
    [types.RECEIVED_HRES62E_POPUP] ({ commit }, popupParams) {
      hres62e.getPopup(popupParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES62E_POPUP, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.RECEIVED_HRES62E_CODLEAVE] ({ commit }, searchParams) {
      hres62e.getCodleave(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES62E_CODLEAVE, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('Try recieve codleave again', message)
          hres62e.getCodleave(searchParams)
            .then((response) => {
              const data2 = JSON.parse(response.request.response)
              commit(types.SET_HRES62E_CODLEAVE, data2)
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data2 = error.response.data
                message = data2.response
              }
              console.warn('warning !!! Please Refresh Page', message)
              if (message !== '' && message !== undefined) {
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              }
            })
        })
    },
    [types.POST_HRES62E_SAVE] ({ commit, dispatch }, { saveParams, searchIndex }) {
      swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
      saveParams.flgwarning = 'N'
      hres62e.postSave({ saveParams, searchIndex })
        .then((response) => {
          const data = JSON.parse(response.request.response)
          if (data.flg === 'warning') {
            swal({
              title: constLabels('confirmTitle'),
              text: data.response,
              html: true,
              showCancelButton: true,
              closeOnConfirm: false,
              confirmButtonText: constLabels('ok'),
              cancelButtonText: constLabels('cancel')
            },
            function (isConfirm) {
              if (isConfirm) {
                swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
                saveParams.flgwarning = 'Y'
                hres62e.postSave({ saveParams, searchIndex })
                .then((response) => {
                  const data = JSON.parse(response.request.response)
                  let searchParams = {
                    p_dtereq: saveParams.dtereq,
                    p_numseq: saveParams.seqno
                  }
                  dispatch(types.RECEIVED_HRES62E_DETAIL, searchParams)
                  swal({
                    title: '', text: data.response, html: true, type: 'success'
                  }, function () {
                    window.onkeydown = null; window.onfocus = null; swal('')
                  })
                })
                .catch((error) => {
                  let message = error
                  if (error.response) {
                    const data = error.response.data
                    message = data.response
                  }
                  console.warn('warning !!! Please Refresh Page', message)
                  if (message !== '' && message !== undefined) {
                    swal({
                      title: '', text: message, html: true, type: 'error'
                    }, function () {
                      window.onkeydown = null; window.onfocus = null; swal('')
                    })
                  }
                })
              }
            })
          } else {
            let searchParams = {
              p_dtereq: saveParams.dtereq,
              p_numseq: saveParams.seqno
            }
            dispatch(types.RECEIVED_HRES62E_DETAIL, searchParams)
            swal({
              title: '', text: data.response, html: true, type: 'success'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.POST_HRES62E_CANCEL] ({ commit, dispatch }, { sendParams, searchIndex }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmCancel'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hres62e.postCancel({ sendParams, searchIndex })
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRES62E_INDEX, searchIndex)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              console.warn('warning !!! Please Refresh Page', message)
              if (message !== '' && message !== undefined) {
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              }
            })
        }
      })
    },
    [types.RECEIVED_HRES62E_WORKTIME] ({ commit }, searchParams) {
      hres62e.getWorktime(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES62E_WORKTIME, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    }
  }
}




// WEBPACK FOOTER //
// ./src/store/modules/hres62e/index.js